/**
 * Shared "daily bonus already shown today" marker.
 *
 * A single localStorage key stamped by EVERY successful daily-bonus claim
 * path (DailyLoginPopup, RewardsPage, Dashboard, Profile) so the popup on
 * the lobby never re-opens once the player has claimed from any other
 * surface today. Also read by DailyLoginPopup's final pre-open guard so a
 * queued `setTimeout(setOpen)` can be aborted if the state changed while
 * it was pending.
 *
 * The date is stored in local-day resolution (YYYY-MM-DD) so the marker
 * naturally rolls over at each player's local midnight — matching the
 * backend's `last_bonus_date` UTC-day-comparison from the user's POV.
 */
export const DAILY_LOGIN_MARKER_KEY = "daily_login_shown_date";

export const todayISO = () => new Date().toISOString().slice(0, 10);

export const stampDailyClaimed = () => {
  try {
    localStorage.setItem(DAILY_LOGIN_MARKER_KEY, todayISO());
  } catch (e) { void e; }
};

export const hasDailyClaimedToday = () => {
  try {
    return localStorage.getItem(DAILY_LOGIN_MARKER_KEY) === todayISO();
  } catch (e) { void e; return false; }
};
